// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
  BooleanField,
  BooleanInput,
} from "react-admin";
import { JsonField, JsonInput } from "react-admin-json-view";

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[100, 300, 500]} {...props} />
);

const CommunesFilter = (props) => (
  <Filter {...props}>
    <TextInput label="id" source="id" alwaysOn />
    <TextInput label="Type" source="type" alwaysOn />
    <TextInput label="Region" source="region" alwaysOn />
    <TextInput label="Province" source="province" alwaysOn />
    <TextInput label="Commune" source="commune" alwaysOn />
    <BooleanInput label="Display" source="display" />
  </Filter>
);

export const CommunesList = (props) => (
  <List {...props} filters={<CommunesFilter />} pagination={<PostPagination />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="type" />
      <TextField source="region" />
      <TextField source="province" />
      <TextField source="commune" />
      <BooleanField source="display" />

      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const CommunesShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="type" />
      <TextField source="region" />
      <TextField source="province" />
      <TextField source="commune" />
      <JsonField source="properties" />
      <BooleanField source="display" />
    </SimpleShowLayout>
  </Show>
);

export const CommunesEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar alwaysEnableSaveButton />}>
      <TextInput source="id" />
      <TextInput source="type" />
      <TextInput source="region" />
      <TextInput source="province" />
      <TextInput source="commune" />
      <JsonInput source="properties" />
      <BooleanInput source="display" />
    </SimpleForm>
  </Edit>
);
